import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/PrivacyPolicy.css'

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-doc">
        <header className="legal-doc-header">
          <Link to="/" className="legal-back">
            ← Back to Home
          </Link>
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </header>

        <div className="legal-doc-body">
          <section className="legal-section">
            <h2>1. Information We Collect</h2>
            <p>We collect information you provide directly to us, such as when you:</p>
            <ul>
              <li>Contact us through our website forms</li>
              <li>Request a quote or consultation</li>
              <li>Sign up for our services</li>
              <li>Subscribe to our newsletter</li>
            </ul>
            <p>This information may include your name, email address, phone number, and project details.</p>
          </section>

          <section className="legal-section">
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide and improve our services</li>
              <li>Communicate with you about your projects</li>
              <li>Send you updates and marketing materials (with your consent)</li>
              <li>Respond to your inquiries and support requests</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Information Sharing</h2>
            <p>
              We do not sell, trade, or otherwise transfer your personal information to third parties without your
              consent, except:
            </p>
            <ul>
              <li>To trusted service providers who assist us in operating our website and conducting our business</li>
              <li>When required by law or to protect our rights and safety</li>
              <li>In connection with a business transfer or merger</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information against unauthorized
              access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Cookies and Tracking</h2>
            <p>
              Our website may use cookies and similar technologies to operate the site, remember preferences, and
              understand how visitors use our pages. You can manage cookie consent through the banner shown on your
              first visit and adjust preferences in your browser settings at any time.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt out of marketing communications</li>
              <li>Withdraw consent at any time</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Children&apos;s Privacy</h2>
            <p>
              Our services are not intended for children under 13. We do not knowingly collect personal information
              from children under 13.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the
              new policy on this page and updating the &quot;Last updated&quot; date.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us at:</p>
            <div className="contact-info">
              <p>Email: thedeverseagency@gmail.com</p>
              <p>We will respond to your inquiry within 24 hours.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
